import { ReactElement, useEffect, useState } from "react";
import AuthenticationRequired from "./AuthenticationRequired";
import "./BreakoutAuthPage.scss";
import { loginWithPersona } from "@technologyfromsage/persona-padlock";
import { logError } from "shared/log";
import AuthenticationHoldingScreen from "./AuthenticationHoldingScreen";
import useNotifications from "shared/Notifications/useNotifications";
import { useAppDispatch } from "shared/redux/hooks";
import { setCurrentUser } from "shared/redux/currentUser";
import { getPersonaConfig } from "shared/AuthenticatedPage/config";

export type BreakoutAuthPageProps = {
  authProvider: string;
};

const BreakoutAuthPage = ({
  authProvider,
}: BreakoutAuthPageProps): ReactElement => {
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { showError, close } = useNotifications();
  const dispatch = useAppDispatch();

  const onAuthenticateHandler = async () => {
    setErrorMessage(null);
    const config = getPersonaConfig(authProvider);

    try {
      setIsAuthenticating(true);
      const response = await loginWithPersona(config);

      dispatch(setCurrentUser(response));
    } catch (error: unknown) {
      if (error instanceof Error) {
        logError(error);
        setErrorMessage(error.message);
      }
    } finally {
      setIsAuthenticating(false);
    }
  };

  useEffect(() => {
    if (errorMessage) {
      showError(errorMessage, {
        timeout: 0,
      });
    } else {
      close();
    }
  }, [close, errorMessage, showError]);

  return (
    <div className="container">
      <main id="content">
        <div className="breakout-auth-page__row row justify-content-center align-content-center">
          <div className="col-6">
            {isAuthenticating ? (
              <AuthenticationHoldingScreen />
            ) : (
              <AuthenticationRequired onAuthenticate={onAuthenticateHandler} />
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default BreakoutAuthPage;
